import { DATE_DD_MM_YYYY } from "common/components/FilterMenu/constants"
import { formatDate } from "common/utils/date"
import { normalizeString } from "common/utils/utils"
import { FORMAS_DE_CONTACTO } from "features/Contactos/constants"
import readXlsx from "read-excel-file"

export const excelToJson = async (file: $TSMigrationFixMe) => {
  const rows = await readXlsx(file)
  const headers = rows.shift()

  const object = rows.map((row) => {
    const item = {}
    row.forEach((value, index) => {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
      item[headers[index]] = value
    })
    return item
  })

  return object
}

const processValue = (value: $TSMigrationFixMe) => {
  if (typeof value === "object" && value !== null) {
    return value instanceof Date ? formatDate(value, DATE_DD_MM_YYYY) : value
  }
  return value ?? null
}

export const CSVToArray = async (file: $TSMigrationFixMe) => {
  const text = await file.text()
  const delimiter = text.indexOf(";") !== -1 ? ";" : ","

  const lines = text.split("\n")
  const headers = lines[0].split(delimiter)

  const data = lines.slice(1).map((line: $TSMigrationFixMe) => {
    const values = line.split(delimiter)
    return headers.reduce(
      (
        obj: $TSMigrationFixMe,
        // @ts-expect-error TS(6133): 'header' is declared but its value is never read.
        header: $TSMigrationFixMe,
        index: $TSMigrationFixMe
      ) => {
        const trimmedValue = values[index] ? values[index].trim() : null
        obj[`col${index}`] = trimmedValue
        return obj
      },
      {}
    )
  })

  const filteredData = data.filter((row: $TSMigrationFixMe) =>
    Object.values(row).some((value) => value !== null)
  )

  return { items: filteredData, headers }
}

export const excelToJsonCols = async (file: $TSMigrationFixMe) => {
  const rows = await readXlsx(file)
  const headers = rows.shift()
  const object = rows.map((row) => {
    const item = {}
    row.forEach((value, index) => {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
      item[`col${index + 1}`] = processValue(value)
    })
    return item
  })

  return { items: object, headers }
}
export const excelToJsonEmails = async (file: $TSMigrationFixMe) => {
  const rows = await readXlsx(file)
  const object = rows.map((row) => {
    const item = {}
    row.forEach((value) => {
      // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
      item.id = Math.random()
      // @ts-expect-error TS(2339): Property 'text' does not exist on type '{}'.
      item.text = value
    })
    return item
  })
  return object
}

export const extractImportObject = ({
  data,
  selectedOptions,
}: $TSMigrationFixMe) => {
  return data
    .map((item: $TSMigrationFixMe) => {
      const mappedArticulo = Object.keys(item).map((key) => {
        const ourColumnKey = selectedOptions[key]
        return ourColumnKey ? { [ourColumnKey]: item[key] } : null
      })

      return Object.assign({}, ...mappedArticulo)
    })
    .filter((o: $TSMigrationFixMe) => Object.keys(o).length)
}

export const mapcontactos = (
  contactos: $TSMigrationFixMe,
  poblaciones: $TSMigrationFixMe
) => {
  return contactos.map((cliente: $TSMigrationFixMe) => {
    const normalizedPoblacion = normalizeString(
      cliente.poblacion
    ).toLocaleLowerCase()
    return {
      calle: cliente.calle,
      codigoPostal: cliente.cp,
      formasContacto: [
        {
          nombre: "email",
          contacto: cliente.email,
          tipoFormaContacto: FORMAS_DE_CONTACTO.EMAIL,
        },
        {
          nombre: "teléfono",
          contacto: cliente.telefono,
          tipoFormaContacto: FORMAS_DE_CONTACTO.TELEFONO,
        },
      ],
      poblacionId: poblaciones.get(normalizedPoblacion)?.id || null,
      nif: cliente.nif,
      razonSocial: cliente.razonSocial,
      camposPersonalizados: cliente.camposPersonalizados,
    }
  })
}
